exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container---1dLtl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: white;\n  font-size: 11px;\n  line-height: 20px;\n  font-weight: 500; }\n  .container---1dLtl button {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 4px;\n    width: 72px;\n    height: 21px;\n    border-radius: 20px;\n    background-color: rgba(255, 255, 255, .36);\n    border: none;\n    color: white;\n    font-size: 10px;\n    font-weight: 400; }\n  .container---1dLtl button span {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      margin-left: 1px; }\n  .container---1dLtl button span svg path {\n        fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"container": "container---1dLtl"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/participation-table/header-toggle/header-toggle.scss
// module id = uN3G
// module chunks = 1